<!--
 * @Descripttion : 成交确认书
 * @version      : 
 * @Author       : karl
 * @Date         : 2021-09-07 17:52:14
 * @LastEditors  : 
 * @LastEditTime : 
-->

<template>
    <div>
        <div class="page">
            <div class="box">
                <div class="flex-box">
                    <div class="flex-left">
                        <img :src="detailData.sessionImgUrl + '?x-oss-process=image/resize,w_320,h_240/quality,q_60'">
                    </div>
                    <div class="flex-right">
                        <h3>{{ detailData.sessionName }}</h3>
                        <p class="gray_txt">机构：{{ detailData.institutionName }}</p>
                        <p class="gray_txt">中标日期：{{ formatDate(detailData.dealTime) }}</p>
                    </div>
                </div>
            </div>

            <div class="box">
                <h3 class="box-tit">{{ detailData.curDealerName }}</h3>
                <table class="table_td_gray">
                    <tr v-if="detailData.dealerType == 2">
                        <td style="width:40%">信用代码</td>
                        <td>{{ detailData.businessLicence }}</td>
                    </tr>
                    <tr v-if="detailData.dealerType == 2">
                        <td style="width:40%">法人/委托人</td>
                        <td>{{ detailData.userTrueName }}</td>
                    </tr>
                    <tr>
                        <td style="width:40%">身份证号</td>
                        <td>{{ detailData.idNum }}</td>
                    </tr>
                    <tr>
                        <td>联系电话</td>
                        <td>{{ detailData.curDealerMobile || '-' }}</td>
                    </tr>
                </table>
            </div>

            <div class="box">
                <h3 class="box-tit">成交车辆及费用</h3>
                <div class="flex-box" v-if="detailData.daBaoPaiType === 0">
                    <div class="flex-left" style="width:90px">
                        <img :src="detailData.primaryImgPath + '?x-oss-process=image/resize,w_320,h_240/quality,q_60'" style="border:0 none;">
                    </div>
                    <div class="flex-right" style="border-bottom: 0.5px solid #E9E9E9;padding-bottom:10px">
                        <h3>{{ detailData.carName }}</h3>
                        <p class="gray_txt">VIN码：{{ detailData.vin }}</p>
                        <p class="gray_txt">车牌：{{ detailData.plate }}</p>
                    </div>
                </div>
                <div class="flex-box" v-else style="background-color: #F3F5F7;border-radius: 8px;padding:15px;">
                    <div class="flex-left">
                        <img :src="detailData.primaryImgPath + '?x-oss-process=image/resize,w_320,h_240/quality,q_60'">
                    </div>
                    <div class="flex-right">
                        <h3>{{ detailData.carName }}</h3>
                        <p><span style="float:right;font-family:SimSun" @click="goToAllCar(detailData.auctionItemID)">查看全部车辆 &gt;</span>共{{ detailData.dbpCarNum }}辆车</p>
                    </div>
                </div>

                <ul class="priceList">
                    <li v-for="item in detailData.priceList" :key="item.key">
                        <span class="gray_txt">{{ item.key }}</span>
                        <span>￥{{ item.value }}</span>
                    </li>
                </ul>
                <div class="totalPrice">合计：<em>￥{{ detailData.totalPrice }}</em></div>
                <p class="paipaiche_tips" v-if="isPaiPaiChe"><i>*</i>所有成交车辆另外收取200元/台储运费(合手价未包含储运费)</p>
                <p class="tipsTxt" v-if="detailData.remark">说明：{{ detailData.remark }}</p>
            </div>
        </div>

        <div class="foot-box">
            <div class="button" @click="goToDealConfirmCreate(detailData.auctionItemID)">我已确认，下一步</div>
        </div>
    </div>
</template>
<script>
import {
    DealConfirmGetDetail
} from "@/request/deal";

export default {
    data() {
        return {
            auctionItemID: '',
            detailData: {},
            isPaiPaiChe: false, //是否是拍拍车
        }
    },
    created() {

    },
    mounted() {

        if (this.$route.query.sessionId) {
            //   公共参数
            this.$store.commit("setUserInfo", {
                sessionKey: this.$route.query.sessionKey,
                clientInstitutionID: this.$route.query.clientInstitutionID,
                sessionId: this.$route.query.sessionId,
                requestSource: this.$route.query.requestSource,
                bundleID: this.$route.query.bundleID,
                requestGroupID: this.$route.query.requestGroupID,
                channel: this.$route.query.channel,
                loginUserID: this.$route.query.loginUserID,
                clientIP: this.$route.query.clientIP,
                endDeviceNumber: this.$route.query.endDeviceNumber,
                cityName: decodeURIComponent(this.$route.query.cityName)
            });
        }

        this.auctionItemID = this.$route.query.aid;

        this.getDetail();

        let _clientInstitutionID = this.$route.query.clientInstitutionID;
        if (_clientInstitutionID == 381 || _clientInstitutionID == 382 || _clientInstitutionID == 406) {
            this.isPaiPaiChe = true;
        } else {
            this.isPaiPaiChe = false;
        }
    },
    methods: {
        getDetail() {
            const that = this;
            // 获取车辆订单确认成交书
            DealConfirmGetDetail({
                auctionItemID: that.auctionItemID
            }).then(res => {
                that.detailData = res.data.data;
            });
        },
        goToAllCar(auctionItemID) {
            location.href = "carwins://gopage?page=dbpvehicledetail&auctionItemId=" + auctionItemID;
        },
        goToDealConfirmCreate(auctionItemID) {
            location.href = "carwins://gopage?page=dealConfirmCreate&auctionItemID=" + auctionItemID + "&sign=" + (this.detailData.isDealConfirmHTSign || 0) + "&isdbp=" + (this.detailData.daBaoPaiType || 0);
        },
        formatDate(date) {
            if (date != null && date != "" && date) {
                var strDate = new Date(date.replace(/-/g, "/"));
                var _year = strDate.getFullYear();
                var _month = strDate.getMonth() + 1;
                if (_month < 10) {
                    _month = "0" + _month;
                }
                var _day = strDate.getDate();
                if (_day < 10) {
                    _day = "0" + _day;
                }
                return _year + "/" + _month + "/" + _day;
            } else {
                return "-";
            }
        }
    },
}
</script>
<style lang="scss" scoped>
*,
*:before,
*:after {
    box-sizing: border-box;
    user-select: none;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

.page {
    background-color: #f3f5f7;
    padding: 15px 15px 80px 15px;

    .box {
        background: #ffffff;
        border-radius: 8px;
        margin-top: 15px;
        padding: 12px 15px;

        .box-tit {
            font-size: 14px;
            color: #332d29;
            font-weight: 700;
            padding-bottom: 12px;
        }
    }

    .box:first-child {
        margin: 0;
    }

    td {
        font-size: 14px;
        // color: #979797;
        padding: 3px;
    }

    .flex-box {
        display: flex;

        .flex-left {
            width: 50px;
        }

        .flex-left img {
            width: 100%;
            object-fit: cover;
            max-height: 68px;
            overflow: hidden;
            border: 1px solid #f3f5f7;
            border-radius: 8px;
        }

        .flex-right {
            flex: 1;
            padding-left: 15px;

            h3 {
                font-size: 14px;
                font-weight: 700;
                padding-bottom: 5px;
            }

            p {
                // color: #979797;
                font-size: 14px;
                padding: 3px 0;
            }
        }
    }

    .priceList {
        padding: 10px 0;

        li {
            height: 26px;
            line-height: 26px;
            display: flex;

            span {
                font-size: 14px;
                color: #332d29;
                font-weight: 700;
            }
        }

        li span:first-child {
            flex: 1;
            font-weight: normal;
        }
    }

    .totalPrice {
        text-align: right;
        font-size: 14px;
        padding: 0 0 15px 0;

        em {
            font-size: 18px;
            color: #ff6600;
            font-style: normal;
            font-weight: 700;
        }
    }

    .tipsTxt {
        font-size: 14px;
        color: #332d29;
        text-align: center;
        background-color: #ffefe5;
        // height: 24px;
        // line-height: 24px;
        border-radius: 4px;
        padding: 5px 8px;
    }
}

.button {
    font-size: 16px;
    color: #ffffff;
    background-color: #ff6600;
    border-radius: 10px;
    height: 40px;
    line-height: 40px;
    width: 100%;
    // margin: 0 auto;
    text-align: center;
}

.foot-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 15px 10%;
}

.paipaiche_tips {
    font-size: 12px;
    color: #000000;
    font-weight: 400;
    text-align: right;
    padding: 5px 0 10px 0;

    i {
        font-size: 12px;
        color: #FF0000;
        font-weight: 400;
        font-style: normal;
    }
}

.gray_txt,
.table_td_gray td {
    font-size: 14px !important;
    color: #979797 !important;
    font-weight: 400 !important;
}
</style>